import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import MoreOptionsMenu from 'components/generic/MoreOptionsMenu'
import { SocialMatchUpUI } from 'types/global'
import { useModalDispatch } from 'hooks/use-modal'
import { ProfileModalsState } from './panels/MyScoresPanel'
import { ProfileModalId } from 'constants/modals'
import { ActionPendingScoreModalType } from './modals/ActionPendingScoreModal'

interface Props {
  id: string
  match: SocialMatchUpUI
  allowDelete?: boolean
  isDisabled?: boolean
}

const SocialMatchCardMenu = ({ id, match, allowDelete = false, isDisabled = false }: Props) => {
  const { t: tSocialMatches } = useTranslation('strSocialMatches')
  const { modalDispatch, modalActions } = useModalDispatch<
    ProfileModalsState,
    ProfileModalId.ACTION_PENDING_SCORE
  >(ProfileModalId.ACTION_PENDING_SCORE)
  const handleClickDelete = useCallback(() => {
    modalDispatch(
      modalActions.setValue({
        match,
        matchId: match.id,
        type: ActionPendingScoreModalType.DELETE,
      })
    )
    modalDispatch(modalActions.openModal())
  }, [modalDispatch, modalActions, match])
  return (
    <MoreOptionsMenu id={id} isDisabled={isDisabled}>
      {allowDelete && (
        <li>
          <button onClick={handleClickDelete}>
            {tSocialMatches('myScores.matchCard.menu.delete')}
          </button>
        </li>
      )}
    </MoreOptionsMenu>
  )
}

export default SocialMatchCardMenu
